import React, {Component} from 'react';
import Editor from './editor';
import Previewer from './previewer';


export default class App extends Component {

  render() {
    const match = /\/preview\/([-_\w]+)\/([-_\w]+)\/?/.exec(window.location.pathname);
    if(match){
      const expoID = match[1];
      const showID = match[2];
      return <Previewer expoID={expoID} showID={showID}/>
    } else {
      return <Editor/>
    }
  }
}



// WEBPACK FOOTER //
// ./src/app.js